import { colors, HStack, VStack } from "goi_common";
import { css } from "@emotion/react";

import { Box, Flex } from "@chakra-ui/react";
import { ReactNode } from "react";

export function DetailsSection() {
  return (
    <VStack gap={42} background="white" padding="0px 24px">
      <VStack gap={16} alignItems="center">
        <div
          css={css`
            text-align: center;
          `}
          className="head2_m gray900"
        >
          고이 PRIME
          <br />
          <b>서비스 상세 안내</b>
        </div>
      </VStack>
      <VStack gap={24}>
        <Box className="subtitle_16_b gray900">
          고이 24시간 상담지원 및 연계 서비스
        </Box>
        <Item
          number="1"
          title="24시간 임종접수/상담지원(1666-9784)"
          description={
            <>
              즉각적인 앰뷸런스 배차, 빈소 확인 및 예약 지원
              <br />
              <b className="green500">전담 전문 상담원, 장례지도사 배정</b>
            </>
          }
        />
        <Item
          number="2"
          title="공설 화장장, 공설 봉안당 우선 추천"
          description={
            <>
              주소지 기반으로 합리적으로 이용할 수 있는
              <br />
              공설 시설 안내
              <b className="green500">[사설 시설 대비 평균 500만원 저렴]</b>
              <br />
              국가유공자, 기초생활수급자 화장비용 무료 예약 안내
            </>
          }
        />

        <Item
          number="3"
          title="장례식장 비용 비교 견적 및 실제 후기 안내"
          description={
            <>
              과다한 비용,{" "}
              <b className="green500">불친절, 불편 장례식장 후기 정보 제공</b>
              <br />
              선불제 및 타 상조 실제 후기, 장례식장 실제 비용 안내
            </>
          }
        />
      </VStack>
    </VStack>
  );
}

const Item = ({
  number,
  title,
  description,
}: {
  number: string;
  title: string;
  description: ReactNode;
}) => {
  return (
    <HStack gap={12}>
      <Flex
        borderRadius="50%"
        border={`1px solid ${colors.orange550}`}
        backgroundColor={colors.orange100}
        width="24px"
        minWidth="24px"
        height="24px"
        justifyContent="center"
        alignItems="center"
        className="subtitle_14_b orange650"
      >
        {number}
      </Flex>
      <VStack>
        <div className="subtitle_14_sb">{title}</div>
        <Box className="caption_12_m gray700" whiteSpace="pre-line">
          {description}
        </Box>
      </VStack>
    </HStack>
  );
};
